import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  useTheme,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId7_1 = ['no54', 'no55', 'no56', 'no57', 'no58', 'no59', 'no60'];

const 영역7_1 = [
  {
    id: 1,
    ko: `54. 정맥로(IV route)나\n        arterial line 만들기`,
    info: ['말초 정맥로 또는 arterial line을 확보 할때 해당된다.'],
    desc: ['해당 없음', '1회당 2점 :'],
  },
  {
    id: 2,
    ko: `55. 일반수액주입\n       (bagor병당1회산정)`,
    info: [
      '새로운 수액을 시작하거나 교환하기 위해 수액이나 IVmedication을 준비하여 환자에게 연결하고, 주기적으로 주입속도를 확인하는 행위 등이 포함된다.',
    ],
    desc: ['해당 없음 ', '1회당 0.5점 :'],
  },
  {
    id: 3,
    ko: `56. 펌프를통한수액주입\n        (bagor병당1회산정)`,
    info: [
      '새로운 수액을 시작하거나 교환하기 위해 수액이나 IVmedication을 준비하여 환자에게 연결하고, 주기적으로 주입속도를 확인하는 행위 등이 포함된다.',
    ],
    desc: ['해당 없음  ', '1회당 1점 :'],
  },
  {
    id: 4,
    ko: '57. 정맥 내 일회성 주입',
    info: [
      'IV bolus로 투약하는 약품으로 투약을 준비하고, 주입하며 기록이 있어야 한다.',
      '지속적 주입 약물은 포함되지 않는다.',
    ],
    desc: ['해당 없음   ', '1회당 0.3점 :'],
  },
  {
    id: 5,
    ko: '58. 수혈 (WB, RBC, FFP, PLT pheresis)',
    info: [
      '혈액의 종류에 관계없이 bag 마다 1회로 산정한다.',
      '혈액준비, 확인, 활력징후측정, 기록, filter 교환이 포함된다.',
      '소아는 팩을 나누어 수혈 할 경우 수혈 횟수 단위로 산정한다.',
    ],
    desc: ['해당 없음    ', '1bag당 3점 :'],
  },
  {
    id: 6,
    ko: `59. 수혈(platelet concentrate, Cryo,\n        Granulocyte 1unit 씩 불출)`,
    info: ['혈소판, cryo, granulocyte가 낱개 bag으로 온 경우를 말한다.'],
    desc: ['해당 없음     ', '1bag당 1점 :'],
  },
  {
    id: 7,
    ko: '60. 비정주투약',
    info: [
      'IM, SC, ID, PO, SL, 비위관, 점적액, 도포제 등',
      '정맥주사를 제외한 모든 경로의 투약을 포함한다.',
      '약품의 개수가 아니고 투약을 위해 환자에게 가는 횟수이다.',
      '방문 1건당 1회 산정 (1회 방문으로 2개 이상 동시 투약하는 경우 1회로 계산한다)',
    ],
    desc: ['해당 없음      ', '1회당 0.5점 : '],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  num54: number;
  setNum54: (num54: number) => void;

  num55: number;
  setNum55: (num55: number) => void;

  num56: number;
  setNum56: (num56: number) => void;

  num57: number;
  setNum57: (num57: number) => void;

  num58: number;
  setNum58: (num58: number) => void;

  num59: number;
  setNum59: (num59: number) => void;

  num60: number;
  setNum60: (num60: number) => void;
}

const KPCSCContents4_2 = (props: Props) => {
  const { palette } = useTheme();

  const {
    disabled,
    setValue,
    getValues,
    setNum54,
    setNum55,
    setNum56,
    setNum57,
    setNum58,
    setNum59,
    setNum60,
    register,
  } = props;

  const [disable54, setDisable54] = useState(false);
  const [disable55, setDisable55] = useState(false);
  const [disable56, setDisable56] = useState(false);
  const [disable57, setDisable57] = useState(false);
  const [disable58, setDisable58] = useState(false);
  const [disable59, setDisable59] = useState(false);
  const [disable60, setDisable60] = useState(false);

  const handleChange7_54_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no54_1', 0);
    setNum54(0);
    setDisable54(true);
  };

  const handleChange7_54_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no54_1', 1);
    setNum54(2);
    setDisable54(false);
  };

  const handleChange7_55_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no55_1', 0);
    setNum55(0);
    setDisable55(true);
  };

  const handleChange7_55_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no55_1', 1);
    setNum55(0.5);
    setDisable55(false);
  };

  const handleChange7_56_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no56_1', 0);
    setNum56(0);
    setDisable56(true);
  };

  const handleChange7_56_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no56_1', 1);
    setNum56(1);
    setDisable56(false);
  };

  const handleChange7_57_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no57_1', 0);
    setNum57(0);
    setDisable57(true);
  };

  const handleChange7_57_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no57_1', 1);
    setNum57(0.3);
    setDisable57(false);
  };

  const handleChange7_58_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no58_1', 0);
    setNum58(0);
    setDisable58(true);
  };

  const handleChange7_58_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no58_1', 1);
    setNum58(0.3);
    setDisable58(false);
  };

  const handleChange7_59_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no59_1', 0);
    setNum59(0);
    setDisable59(true);
  };

  const handleChange7_59_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no59_1', 1);
    setNum59(0.3);
    setDisable59(false);
  };

  const handleChange7_60_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no60_1', 0);
    setNum60(0);
    setDisable60(true);
  };

  const handleChange7_60_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no60_1', 1);
    setNum60(0.3);
    setDisable60(false);
  };

  return (
    <>
      <SectionTitle title="영역 : 투약 및 수혈" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '-30px' }}>
          <TableBody>
            {영역7_1.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역7_1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역7_1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '43px' : '28px',
                        marginTop: content.ko.includes('58.')
                          ? '20px'
                          : content.ko.includes('60.')
                          ? '32px'
                          : '0px',
                      }}
                      name={radioId7_1[content.id - 1]}
                      defaultValue={Number(
                        getValues(radioId7_1[content.id - 1])
                      )}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no54'}
                                  value={i}
                                  onChange={handleChange7_54_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no54'}
                                  value={i}
                                  onChange={handleChange7_54_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no55'}
                                  value={i}
                                  onChange={handleChange7_55_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 0.5점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no55'}
                                  value={i}
                                  onChange={handleChange7_55_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음  ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no56'}
                                  value={i}
                                  onChange={handleChange7_56_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no56'}
                                  value={i}
                                  onChange={handleChange7_56_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음   ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no57'}
                                  value={i}
                                  onChange={handleChange7_57_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 0.3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no57'}
                                  value={i}
                                  onChange={handleChange7_57_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음    ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no58'}
                                  value={i}
                                  onChange={handleChange7_58_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1bag당 3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no58'}
                                  value={i}
                                  onChange={handleChange7_58_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음     ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no59'}
                                  value={i}
                                  onChange={handleChange7_59_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1bag당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no59'}
                                  value={i}
                                  onChange={handleChange7_59_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음      ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no60'}
                                  value={i}
                                  onChange={handleChange7_60_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 0.5점 : ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no60'}
                                  value={i}
                                  onChange={handleChange7_60_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역7_1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '17px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable54 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no54_1', {
                                    onChange: e => {
                                      setValue(
                                        'no54_1',
                                        Number(e.target.value)
                                      );
                                      setNum54(Number(getValues('no54_1')) * 2);
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 0.5점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable55 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no55_1', {
                                    onChange: e => {
                                      setValue(
                                        'no55_1',
                                        Number(e.target.value)
                                      );
                                      setNum55(
                                        Number(getValues('no55_1')) * 0.5
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable56 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no56_1', {
                                    onChange: e => {
                                      setValue(
                                        'no56_1',
                                        Number(e.target.value)
                                      );
                                      setNum56(Number(getValues('no56_1')));
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 0.3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable57 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no57_1', {
                                    onChange: e => {
                                      setValue(
                                        'no57_1',
                                        Number(e.target.value)
                                      );
                                      setNum57(
                                        Number(getValues('no57_1')) * 0.3
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1bag당 3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable58 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', 'bag'),
                                  }}
                                  {...register('no58_1', {
                                    onChange: e => {
                                      setValue(
                                        'no58_1',
                                        Number(e.target.value)
                                      );
                                      setNum58(Number(getValues('no58_1')) * 3);
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1bag당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable59 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', 'bag'),
                                  }}
                                  {...register('no59_1', {
                                    onChange: e => {
                                      setValue(
                                        'no59_1',
                                        Number(e.target.value)
                                      );
                                      setNum59(Number(getValues('no59_1')));
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 0.5점 : ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable60 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no60_1', {
                                    onChange: e => {
                                      setValue(
                                        'no60_1',
                                        Number(e.target.value)
                                      );
                                      setNum60(
                                        Number(getValues('no60_1')) * 0.5
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>{v}</Box>
                            </TableRow>
                          );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCContents4_2;
